"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CccisdInput = _interopRequireDefault(require("../../../CccisdInput"));
var _formik = require("formik");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StringValue = function StringValue(props) {
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: props.name,
    component: _CccisdInput["default"],
    label: "",
    placeholder: "Enter value",
    showErrorImmediately: true
  });
};
StringValue.propTypes = {
  name: _propTypes["default"].string
};
var _default = exports["default"] = StringValue;